import React from "react";
import { TwilioConfigForm } from "./TwilioConfigForm";
import { TwilioWebhookCard } from "./TwilioWebhookCard";
import { TwilioTestSmsCard } from "./TwilioTestSmsCard";
import { TwilioCostCard } from "./TwilioCostCard";

export const TwilioConfigTab = ({ cfg, onChanged, onCostLoaded }) => (
  <div className="space-y-6" data-testid="tw-config-tab">
    <TwilioConfigForm cfg={cfg} onChanged={onChanged} />
    <div className="grid lg:grid-cols-2 gap-6">
      <TwilioWebhookCard cfg={cfg} />
      <TwilioTestSmsCard cfg={cfg} onChanged={onChanged} />
    </div>
    <TwilioCostCard onLoaded={onCostLoaded} />
  </div>
);
